"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.INDUSTRY_TYPE_TO_PROFESSION = exports.Professions = void 0;
var enums_1 = require("../../../enums");
/**
 * Consolidated set of professions introduced for RND24 FSU.
 *
 * These are based on `IndustryTypeEnum`.
 */
exports.Professions = {
    ADMIN_AND_SUPPORT: 'Admin and support',
    AGRICULTURE: 'Agriculture',
    ARTS_ENTERTAINMENT_AND_RECREATION: 'Arts, entertainment and recreation',
    CONSTRUCTION: 'Construction',
    CREATIVE_INDUSTRIES: 'Creative industries',
    EDUCATION: 'Education',
    ENVIRONMENTAL_SERVICES: 'Environmental services',
    FOOD_BEVERAGE_AND_HOSPITALITY_INDUSTRIES: 'Food, beverage and hospitality industries',
    FINANCIAL_SERVICES: 'Financial services',
    HEALTH_FITNESS_AND_SOCIAL_CARE: 'Health, fitness and social care',
    IT_AND_COMMUNICATIONS: 'IT and communications',
    LEISURE_TRAVEL_AND_TOURISM: 'Leisure, travel and tourism',
    MANUFACTURING: 'Manufacturing',
    OTHER_SERVICES: 'Other services',
    PROFESSIONAL_AND_TECHNICAL: 'Professional and technical',
    PUBLIC_SECTOR_AND_DEFENCE: 'Public sector and defence',
    REAL_ESTATE_ACTIVITIES: 'Real estate activities',
    RELIGIOUS_INSTITUTIONS: 'Religious institutions',
    RETAIL_AND_WHOLESALE: 'Retail and wholesale',
    TRANSPORT: 'Transport',
    UTILITIES: 'Utilities',
};
/**
 * Maps from `IndustryTypeEnum` to `Professions`.
 */
exports.INDUSTRY_TYPE_TO_PROFESSION = (_a = {},
    _a[enums_1.IndustryTypeEnum.Accounting] = 'Financial services',
    _a[enums_1.IndustryTypeEnum.AirlinesAviation] = 'Transport',
    _a[enums_1.IndustryTypeEnum.AlternativeDisputeResolution] = 'Other services',
    _a[enums_1.IndustryTypeEnum.AlternativeMedicine] = 'Health, fitness and social care',
    _a[enums_1.IndustryTypeEnum.Animation] = 'Creative industries',
    _a[enums_1.IndustryTypeEnum.ApparelFashion] = 'Retail and wholesale',
    _a[enums_1.IndustryTypeEnum.ArchitecturePlanning] = 'Construction',
    _a[enums_1.IndustryTypeEnum.ArtsAndCrafts] = 'Arts, entertainment and recreation',
    _a[enums_1.IndustryTypeEnum.Automotive] = 'Transport',
    _a[enums_1.IndustryTypeEnum.AviationAerospace] = 'Transport',
    _a[enums_1.IndustryTypeEnum.Banking] = 'Financial services',
    _a[enums_1.IndustryTypeEnum.Biotechnology] = 'Professional and technical',
    _a[enums_1.IndustryTypeEnum.BroadcastMedia] = 'Arts, entertainment and recreation',
    _a[enums_1.IndustryTypeEnum.BuildingMaterials] = 'Construction',
    _a[enums_1.IndustryTypeEnum.BusinessSuppliesEquipment] = 'Retail and wholesale',
    _a[enums_1.IndustryTypeEnum.CapitalMarkets] = 'Financial services',
    _a[enums_1.IndustryTypeEnum.Chemicals] = 'Manufacturing',
    _a[enums_1.IndustryTypeEnum.CivicSocialOrganization] = 'Public sector and defence',
    _a[enums_1.IndustryTypeEnum.CivilEngineering] = 'Professional and technical',
    _a[enums_1.IndustryTypeEnum.CommercialRealEstate] = 'Real estate activities',
    _a[enums_1.IndustryTypeEnum.ComputerGames] = 'IT and communications',
    _a[enums_1.IndustryTypeEnum.ComputerHardware] = 'IT and communications',
    _a[enums_1.IndustryTypeEnum.ComputerNetworking] = 'IT and communications',
    _a[enums_1.IndustryTypeEnum.ComputerNetworkSecurity] = 'IT and communications',
    _a[enums_1.IndustryTypeEnum.ComputerSoftware] = 'IT and communications',
    _a[enums_1.IndustryTypeEnum.Construction] = 'Construction',
    _a[enums_1.IndustryTypeEnum.ConsumerElectronics] = 'Manufacturing',
    _a[enums_1.IndustryTypeEnum.ConsumerGoods] = 'Manufacturing',
    _a[enums_1.IndustryTypeEnum.ConsumerServices] = 'Admin and support',
    _a[enums_1.IndustryTypeEnum.Cosmetics] = 'Retail and wholesale',
    _a[enums_1.IndustryTypeEnum.Dairy] = 'Agriculture',
    _a[enums_1.IndustryTypeEnum.DefenseSpace] = 'Public sector and defence',
    _a[enums_1.IndustryTypeEnum.Design] = 'Creative industries',
    _a[enums_1.IndustryTypeEnum.EducationManagement] = 'Education',
    _a[enums_1.IndustryTypeEnum.Elearning] = 'Education',
    _a[enums_1.IndustryTypeEnum.ElectricalElectronicManufacturing] = 'Manufacturing',
    _a[enums_1.IndustryTypeEnum.Entertainment] = 'Arts, entertainment and recreation',
    _a[enums_1.IndustryTypeEnum.EnvironmentalServices] = 'Environmental services',
    _a[enums_1.IndustryTypeEnum.EventsServices] = 'Other services',
    _a[enums_1.IndustryTypeEnum.ExecutiveOffice] = 'Admin and support',
    _a[enums_1.IndustryTypeEnum.FacilitiesServices] = 'Other services',
    _a[enums_1.IndustryTypeEnum.Farming] = 'Agriculture',
    _a[enums_1.IndustryTypeEnum.FinancialServices] = 'Financial services',
    _a[enums_1.IndustryTypeEnum.FineArt] = 'Arts, entertainment and recreation',
    _a[enums_1.IndustryTypeEnum.Fishery] = 'Agriculture',
    _a[enums_1.IndustryTypeEnum.FoodBeverages] = 'Food, beverage and hospitality industries',
    _a[enums_1.IndustryTypeEnum.FoodProduction] = 'Food, beverage and hospitality industries',
    _a[enums_1.IndustryTypeEnum.FundRaising] = 'Other services',
    _a[enums_1.IndustryTypeEnum.Furniture] = 'Retail and wholesale',
    _a[enums_1.IndustryTypeEnum.GamblingCasinos] = 'Arts, entertainment and recreation',
    _a[enums_1.IndustryTypeEnum.GlassCeramicsConcrete] = 'Manufacturing',
    _a[enums_1.IndustryTypeEnum.GovernmentAdministration] = 'Public sector and defence',
    _a[enums_1.IndustryTypeEnum.GovernmentRelations] = 'Public sector and defence',
    _a[enums_1.IndustryTypeEnum.GraphicDesign] = 'Creative industries',
    _a[enums_1.IndustryTypeEnum.HealthWellnessFitness] = 'Health, fitness and social care',
    _a[enums_1.IndustryTypeEnum.HigherEducation] = 'Education',
    _a[enums_1.IndustryTypeEnum.HospitalHealthCare] = 'Health, fitness and social care',
    _a[enums_1.IndustryTypeEnum.Hospitality] = 'Leisure, travel and tourism',
    _a[enums_1.IndustryTypeEnum.HumanResources] = 'Professional and technical',
    _a[enums_1.IndustryTypeEnum.ImportAndExport] = 'Retail and wholesale',
    _a[enums_1.IndustryTypeEnum.IndividualFamilyServices] = 'Health, fitness and social care',
    _a[enums_1.IndustryTypeEnum.IndustrialAutomation] = 'Manufacturing',
    _a[enums_1.IndustryTypeEnum.InformationServices] = 'IT and communications',
    _a[enums_1.IndustryTypeEnum.InformationTechnologyServices] = 'IT and communications',
    _a[enums_1.IndustryTypeEnum.Insurance] = 'Financial services',
    _a[enums_1.IndustryTypeEnum.InternationalAffairs] = 'Public sector and defence',
    _a[enums_1.IndustryTypeEnum.InternationalTradeDevelopment] = 'Public sector and defence',
    _a[enums_1.IndustryTypeEnum.Internet] = 'IT and communications',
    _a[enums_1.IndustryTypeEnum.InvestmentBanking] = 'Financial services',
    _a[enums_1.IndustryTypeEnum.InvestmentManagement] = 'Financial services',
    _a[enums_1.IndustryTypeEnum.Judiciary] = 'Professional and technical',
    _a[enums_1.IndustryTypeEnum.LawEnforcement] = 'Public sector and defence',
    _a[enums_1.IndustryTypeEnum.LawPractice] = 'Professional and technical',
    _a[enums_1.IndustryTypeEnum.LegalServices] = 'Professional and technical',
    _a[enums_1.IndustryTypeEnum.LegislativeOffice] = 'Public sector and defence',
    _a[enums_1.IndustryTypeEnum.LeisureTravelTourism] = 'Leisure, travel and tourism',
    _a[enums_1.IndustryTypeEnum.Libraries] = 'Leisure, travel and tourism',
    _a[enums_1.IndustryTypeEnum.LogisticsSupplyChain] = 'Manufacturing',
    _a[enums_1.IndustryTypeEnum.LuxuryGoodsJewelry] = 'Retail and wholesale',
    _a[enums_1.IndustryTypeEnum.Machinery] = 'Manufacturing',
    _a[enums_1.IndustryTypeEnum.ManagementConsulting] = 'Professional and technical',
    _a[enums_1.IndustryTypeEnum.Maritime] = 'Professional and technical',
    _a[enums_1.IndustryTypeEnum.MarketingAdvertising] = 'Creative industries',
    _a[enums_1.IndustryTypeEnum.MarketResearch] = 'Professional and technical',
    _a[enums_1.IndustryTypeEnum.MechanicalIndustrialEngineering] = 'Professional and technical',
    _a[enums_1.IndustryTypeEnum.MediaProduction] = 'Creative industries',
    _a[enums_1.IndustryTypeEnum.MedicalDevices] = 'Manufacturing',
    _a[enums_1.IndustryTypeEnum.MedicalPractice] = 'Health, fitness and social care',
    _a[enums_1.IndustryTypeEnum.MentalHealthCare] = 'Health, fitness and social care',
    _a[enums_1.IndustryTypeEnum.Military] = 'Public sector and defence',
    _a[enums_1.IndustryTypeEnum.MiningMetals] = 'Manufacturing',
    _a[enums_1.IndustryTypeEnum.MotionPicturesFilm] = 'Arts, entertainment and recreation',
    _a[enums_1.IndustryTypeEnum.MuseumsInstitutions] = 'Arts, entertainment and recreation',
    _a[enums_1.IndustryTypeEnum.Music] = 'Arts, entertainment and recreation',
    _a[enums_1.IndustryTypeEnum.Nanotechnology] = 'Professional and technical',
    _a[enums_1.IndustryTypeEnum.Newspapers] = 'Creative industries',
    _a[enums_1.IndustryTypeEnum.NonProfitOrganizationManagement] = 'Other services',
    _a[enums_1.IndustryTypeEnum.OilEnergy] = 'Professional and technical',
    _a[enums_1.IndustryTypeEnum.OnlineMedia] = 'Creative industries',
    _a[enums_1.IndustryTypeEnum.OutsourcingOffshoring] = 'Other services',
    _a[enums_1.IndustryTypeEnum.PackageFreightDelivery] = 'Transport',
    _a[enums_1.IndustryTypeEnum.PackagingContainers] = 'Manufacturing',
    _a[enums_1.IndustryTypeEnum.PaperForestProducts] = 'Manufacturing',
    _a[enums_1.IndustryTypeEnum.PerformingArts] = 'Arts, entertainment and recreation',
    _a[enums_1.IndustryTypeEnum.Pharmaceuticals] = 'Manufacturing',
    _a[enums_1.IndustryTypeEnum.Philanthropy] = 'Other services',
    _a[enums_1.IndustryTypeEnum.Photography] = 'Creative industries',
    _a[enums_1.IndustryTypeEnum.Plastics] = 'Manufacturing',
    _a[enums_1.IndustryTypeEnum.PoliticalOrganization] = 'Public sector and defence',
    _a[enums_1.IndustryTypeEnum.PrimarySecondaryEducation] = 'Education',
    _a[enums_1.IndustryTypeEnum.Printing] = 'Other services',
    _a[enums_1.IndustryTypeEnum.ProfessionalTrainingCoaching] = 'Professional and technical',
    _a[enums_1.IndustryTypeEnum.ProgramDevelopment] = 'Other services',
    _a[enums_1.IndustryTypeEnum.PublicPolicy] = 'Public sector and defence',
    _a[enums_1.IndustryTypeEnum.PublicRelationsCommunications] = 'IT and communications',
    _a[enums_1.IndustryTypeEnum.PublicSafety] = 'Public sector and defence',
    _a[enums_1.IndustryTypeEnum.Publishing] = 'Creative industries',
    _a[enums_1.IndustryTypeEnum.RailroadManufacture] = 'Manufacturing',
    _a[enums_1.IndustryTypeEnum.Ranching] = 'Agriculture',
    _a[enums_1.IndustryTypeEnum.RealEstate] = 'Real estate activities',
    _a[enums_1.IndustryTypeEnum.RecreationalFacilitiesServices] = 'Arts, entertainment and recreation',
    _a[enums_1.IndustryTypeEnum.ReligiousInstitutions] = 'Religious institutions',
    _a[enums_1.IndustryTypeEnum.RenewablesEnvironment] = 'Environmental services',
    _a[enums_1.IndustryTypeEnum.Research] = 'Professional and technical',
    _a[enums_1.IndustryTypeEnum.Restaurants] = 'Food, beverage and hospitality industries',
    _a[enums_1.IndustryTypeEnum.Retail] = 'Retail and wholesale',
    _a[enums_1.IndustryTypeEnum.SecurityInvestigations] = 'Public sector and defence',
    _a[enums_1.IndustryTypeEnum.Semiconductors] = 'Manufacturing',
    _a[enums_1.IndustryTypeEnum.ShipBuilding] = 'Manufacturing',
    _a[enums_1.IndustryTypeEnum.SportingGoods] = 'Retail and wholesale',
    _a[enums_1.IndustryTypeEnum.Sports] = 'Arts, entertainment and recreation',
    _a[enums_1.IndustryTypeEnum.StaffingRecruiting] = 'Professional and technical',
    _a[enums_1.IndustryTypeEnum.Supermarkets] = 'Retail and wholesale',
    _a[enums_1.IndustryTypeEnum.Telecommunications] = 'IT and communications',
    _a[enums_1.IndustryTypeEnum.Textiles] = 'Manufacturing',
    _a[enums_1.IndustryTypeEnum.ThinkTanks] = 'Public sector and defence',
    _a[enums_1.IndustryTypeEnum.Tobacco] = 'Retail and wholesale',
    _a[enums_1.IndustryTypeEnum.TranslationLocalization] = 'Professional and technical',
    _a[enums_1.IndustryTypeEnum.TransportationTruckingRailroad] = 'Transport',
    _a[enums_1.IndustryTypeEnum.Utilities] = 'Utilities',
    _a[enums_1.IndustryTypeEnum.VentureCapitalPrivateEquity] = 'Financial services',
    _a[enums_1.IndustryTypeEnum.Veterinary] = 'Professional and technical',
    _a[enums_1.IndustryTypeEnum.Warehousing] = 'Other services',
    _a[enums_1.IndustryTypeEnum.Wholesale] = 'Retail and wholesale',
    _a[enums_1.IndustryTypeEnum.WineSpirits] = 'Food, beverage and hospitality industries',
    _a[enums_1.IndustryTypeEnum.Wireless] = 'IT and communications',
    _a[enums_1.IndustryTypeEnum.WritingEditing] = 'Creative industries',
    _a);
//# sourceMappingURL=professions.js.map